module.exports = __webpack_public_path__ + "img/alturamaxima.f4b2fd9f.png";